<template>
    <div class="agenda-item">
        <span class="card__subject pb-2 d-block">{{ agendaItem.month }}</span>
        <ul class="mb-2 list-unstyled card__list">
            <li
                v-for="date in agendaItem.items"
                :key="date.day"
                class="agenda-item__item"
            >
                <span
                    class="agenda-item__date position-absolute color--blue font-italic"
                    >{{ date.day }}</span
                >
                <a
                    v-if="date.link"
                    class="agenda-item__link"
                    target="_blank"
                    :href="date.link"
                    >{{ date.text }}</a
                >
                <span v-else>{{ date.text }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        agendaItem: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss">
.agenda-item {
    flex: 1 1 100%;
}

.agenda-item__item {
    position: relative;
    padding-left: 2rem;
}

.agenda-item__date {
    left: 0;
}

.agenda-item__link {
    font-weight: $font-weight-bold;
    color: $brand-blue-dark;
}
</style>
